import { render, staticRenderFns } from "./EachCountryAssessmentCard.vue?vue&type=template&id=6858ea5a&scoped=true&"
import script from "./EachCountryAssessmentCard.vue?vue&type=script&lang=js&"
export * from "./EachCountryAssessmentCard.vue?vue&type=script&lang=js&"
import style0 from "./EachCountryAssessmentCard.vue?vue&type=style&index=0&id=6858ea5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6858ea5a",
  null
  
)

export default component.exports